import { getBonus } from '@monorepo/utils'

export const CAPTCHA_KEY = (typeof window !== 'undefined' && window.env.APP_CAPTCHA_KEY) || ''
export const bonus = getBonus({
  name: 'wheel11',
  appBonus: typeof window !== 'undefined' ? window.env.APP_BONUSES : undefined,
})

